/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';

import isEqual from 'lodash/isEqual';

import CollapsableItem from '../../utils/CollapsableItem';
import { isMobileResolution } from '../../../infrastructure/utils/common';
import ActivitySectionButtons from '../ActivitySectionButtons';
import Disable from "../../utils/Disable";

import ActivityTagFieldsMobile from './ActivityTagFieldsMobile';
import ActivitiesTagsForm from './ActivitiesTagsForm';

const ActivityTagFields = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  tags,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  allTags,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  updateActivity,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setIsBookingOptionModalOpen,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  originalActivity,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedTags,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setSelectedTags,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  disabled,
}) => {
  if (!tags) return null;
  const [initalTags, setInitialTags] = useState([...tags]);

  const werePropertiesChanged = () => !isEqual(selectedTags, initalTags);

  const onSaveClick = async event => {
    event.preventDefault();
    const result = await updateActivity({ tags: selectedTags });
    setInitialTags(result);
  };

  const onResetClick = () => {
    setSelectedTags(initalTags);
  };

  if (isMobileResolution()) {
    return (
      <ActivityTagFieldsMobile
        selectedTags={selectedTags}
        onChange={setSelectedTags}
        allTags={allTags}
        onSaveClick={onSaveClick}
        onResetClick={onResetClick}
        disabled={!werePropertiesChanged()}
      />
    );
  }

  return (
    <Disable disabled className='data-box'>
      <div className='activity-section-top'>
        <h4 className='header'>Experience Tags</h4>
        <ActivitySectionButtons
          onSaveClick={onSaveClick}
          onResetClick={onResetClick}
          disabled={!werePropertiesChanged()}
        />
      </div>
      <CollapsableItem isExpanded>
        <ActivitiesTagsForm
          selectedTags={selectedTags}
          allTags={allTags}
          onChange={setSelectedTags}
          setIsBookingOptionModalOpen={setIsBookingOptionModalOpen}
          originalActivity={originalActivity}
          disabled={disabled}
        />
      </CollapsableItem>
    </Disable>
  );
};

export default React.memo(ActivityTagFields);
